module.exports = __webpack_public_path__ + "static/media/Royal-Bank-of-Canada-Logo.b67ffaff.png";